<template>
  <div>
    <div class="box" :value="confirmEvent">
      <div class="border-box">
        <div class="inner-box">
          <BInputTextArea
            class="area-class"
            v-model="introduce"
            placeholder="请输入个人介绍"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { saveIntroduce } from "@/api/teacherManagement";
import BInputTextArea from "../../components2/BInputTextArea";

export default {
  name: "PopupContents",
  props: {
    data: Object,
    confirmEvent: Boolean,
  },
  components: {
    BInputTextArea,
  },
  watch: {
    confirmEvent() {
      if (this.confirmEvent === true || this.confirmEvent === null) {
        this.save();
      }
    },
  },
  data() {
    return {
      introduce: "",
    };
  },
  mounted() {
    if (
      this.data.introduce !== null &&
      this.data.introduce !== "" &&
      this.data.introduce !== undefined
    ) {
      this.introduce = this.data.introduce;
    }
  },
  methods: {
    result(value) {
      this.returnData = value;
      this.$emit("ok", this.returnData);
    },
    async save() {
      var param = {
        id: this.data.id,
        introduce: this.introduce,
      };
      const data = await saveIntroduce(param);
      if (data.code === 0) {
        this.$emit("input", false);
        this.result(0);
        Vue.prototype.$vsnackbar.show(data.msg);
      } else {
        this.$emit("input", false);
        Vue.prototype.$vsnackbar.show(data.msg);
      }
    },
  },
};
</script>

<style scoped>
.area-class {
  width: 500px;
  height: 240px;
}
.box {
  display: flex;
  flex-direction: column;
  height: 240px;
}

.border-box {
  display: flex;
  width: 500px;
  height: 350px;
}

.inner-box {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  position: relative;
  justify-content: center;
  height: 200px;
}
</style>
